// extracted by mini-css-extract-plugin
module.exports = {"vaultTable":"VaultTable_vaultTable__2dRY5","red":"VaultTable_red__20o9M","green":"VaultTable_green__CaLN0","sep":"VaultTable_sep__uv8qm"};